import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { checkboxCommonPropsNative, getCheckboxCss } from '../Checkbox/Checkbox.mapper'
import { CheckboxGroupCSSVars, CheckboxGroupDefinition } from './CheckboxGroup'

export const css = withCompInfo<CheckboxGroupCSSVars, CheckboxGroupDefinition>()(
	[
		'compProps',
		'compData',
		'compLayout',
		'hasResponsiveLayout',
		'structure',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	(deps) => {
		// @ts-ignore
		const { compProps, compData, compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated } = deps
		const compInfo = {
			compLayout,
			styleProperties,
			siteFonts,
			isMobileView,
			compProps,
		}
		const { layout, alignment, buttonsMargin, labelMobileFontSize } = compProps
		const labelMargin = (compData.label?.length > 0 && compProps.labelMargin) || 0
		const isHorizontalAlignment = layout === 'horizontal'

		const horizontalItemsMargin = alignment === 'right' ? `0 0 0 ${buttonsMargin}px` : `0 ${buttonsMargin}px 0 0`

		return {
			'--fnt2': getScaledFont(compInfo, 'fnt2', isOneDocMigrated, labelMobileFontSize),
			'--groupLabelMargin': `0 0 ${labelMargin}px 0`,
			'--textAlign': alignment,
			'--requiredIndicationDisplay':
				styleProperties.txtlblrq && styleProperties.txtlblrq !== 'transparent' ? 'inline' : 'none',
			'--itemsFlexDirection': isHorizontalAlignment ? 'row' : 'column',
			'--itemsMargin': isHorizontalAlignment ? horizontalItemsMargin : `0 0 ${buttonsMargin}px 0`,
			...(!isHorizontalAlignment && { '--itemsWidth': '100%' }),
			// @ts-ignore
			...getCheckboxCss({ ...deps, siteFonts, isOneDocMigrated }),
		}
	}
)

export const props = withCompInfo<any, CheckboxGroupDefinition>()(
	['compProps', 'compData', 'isMobileView'],
	({ compProps, compData, isMobileView }) => {
		const { options = [], label } = compData as any

		const { required, isDisabled } = compProps as any

		const parsedOptions = options.map((checkboxData: any) => {
			return checkboxCommonPropsNative({
				compData: checkboxData,
				required,
				readOnly: false,
				isDisabled,
				isMobileView,
			})
		})

		return {
			label,
			options: parsedOptions,
			required,
			isDisabled,
		}
	}
)
